// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&&& {
            ${xScreen("lte", "sm")}{
                margin-top: 25px;
            }
        }
    `,
};

scheduleReminderModalStyles.intervalGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        align-items: end;
    `,
};

scheduleReminderModalStyles.scheduleButtonGridItem = {
    css: css`
        justify-content: flex-end;
        &&&& {
            max-width: 100%;
        }
    `,
};

scheduleReminderModalStyles.stopButtonGridItem = {
    css: css`
        &&&& {
            max-width: 100%;
        }
    `,
};

scheduleReminderModalStyles.cancelButtonGridItem = {
    css: css`
        &&&& {
            max-width: 100%;
        }
    `,
};


scheduleReminderModalStyles.stopButton = {
    ...scheduleReminderModalStyles.stopButton,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    }
};

scheduleReminderModalStyles.buttonsContainer = {
    gap: 20,
    css: css`
        & ${GridOffset} {
            justify-content: flex-end;
            ${xScreen("lt", "sm")} {
                flex-direction: column;
                > ${GridItemStyle} > button {
                    width: 100%;
                }
            }
        }
    `,
};

scheduleReminderModalStyles.hintText = {
    css: css`
        margin-top: 5px;
        border-bottom: none !important;
    `,
};

scheduleReminderModalStyles.headlineWraper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};